// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["turnstile-styles"], () => (__webpack_require__("./sources/ts/turnstile.ts")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["turnstile-styles"], () => (__webpack_require__("./sources/scss/frontend/turnstile.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
